import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import dayjs from 'dayjs';
import customParseFormatPlugin from 'dayjs/plugin/customParseFormat';
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat';
import updateLocalePlugin from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/uk';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ar';

dayjs.extend(customParseFormatPlugin);
dayjs.extend(localizedFormatPlugin);
dayjs.extend(updateLocalePlugin);

/** Supported Application Languages. */
export const langs = ['en', 'de', 'es', 'fr', 'it', 'uk', 'ar'];

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        interpolation: { escapeValue: false },
        partialBundledLanguages: true,
        supportedLngs: langs,
        fallbackLng: langs,
        resources: {},
        ns: [],
    });

const updateLanguage = (lang: string) => dayjs.locale(lang);

i18n.on('languageChanged', updateLanguage);

updateLanguage(i18n.language);

export const translations = () => {
    langs.forEach(async lang => {
        const moduleLangs = await import(`./translations/translations_${lang}`);
        i18n.addResourceBundle(lang, 'translations', moduleLangs.default);
    });
};

translations();
export default i18n;
